var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var stream = require('readable-stream');

var Box = require('mp4-box-encoding');

function noop() {}

var Encoder = /*#__PURE__*/function (_stream$Readable) {
  "use strict";

  _inherits(Encoder, _stream$Readable);

  function Encoder(opts) {
    var _this;

    _classCallCheck(this, Encoder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Encoder).call(this, opts));
    _this.destroyed = false;
    _this._finalized = false;
    _this._reading = false;
    _this._stream = null;
    _this._drain = null;
    _this._want = false;

    _this._onreadable = function () {
      if (!_this._want) return;
      _this._want = false;

      _this._read();
    };

    _this._onend = function () {
      _this._stream = null;
    };

    return _this;
  }

  _createClass(Encoder, [{
    key: "mdat",
    value: function mdat(size, cb) {
      this.mediaData(size, cb);
    }
  }, {
    key: "mediaData",
    value: function mediaData(size, cb) {
      var stream = new MediaData(this);
      this.box({
        type: 'mdat',
        contentLength: size,
        encodeBufferLen: 8,
        stream: stream
      }, cb);
      return stream;
    }
  }, {
    key: "box",
    value: function box(_box, cb) {
      if (!cb) cb = noop;
      if (this.destroyed) return cb(new Error('Encoder is destroyed'));
      var buf;

      if (_box.encodeBufferLen) {
        buf = Buffer.alloc(_box.encodeBufferLen);
      }

      if (_box.stream) {
        _box.buffer = null;
        buf = Box.encode(_box, buf);
        this.push(buf);
        this._stream = _box.stream;

        this._stream.on('readable', this._onreadable);

        this._stream.on('end', this._onend);

        this._stream.on('end', cb);

        this._forward();
      } else {
        buf = Box.encode(_box, buf);
        var drained = this.push(buf);
        if (drained) return process.nextTick(cb);
        this._drain = cb;
      }
    }
  }, {
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;
      if (this._stream && this._stream.destroy) this._stream.destroy();
      this._stream = null;

      if (this._drain) {
        var cb = this._drain;
        this._drain = null;
        cb(err);
      }

      if (err) this.emit('error', err);
      this.emit('close');
    }
  }, {
    key: "finalize",
    value: function finalize() {
      this._finalized = true;

      if (!this._stream && !this._drain) {
        this.push(null);
      }
    }
  }, {
    key: "_forward",
    value: function _forward() {
      if (!this._stream) return;

      while (!this.destroyed) {
        var buf = this._stream.read();

        if (!buf) {
          this._want = !!this._stream;
          return;
        }

        if (!this.push(buf)) return;
      }
    }
  }, {
    key: "_read",
    value: function _read() {
      if (this._reading || this.destroyed) return;
      this._reading = true;
      if (this._stream) this._forward();

      if (this._drain) {
        var drain = this._drain;
        this._drain = null;
        drain();
      }

      this._reading = false;

      if (this._finalized) {
        this.push(null);
      }
    }
  }]);

  return Encoder;
}(stream.Readable);

var MediaData = /*#__PURE__*/function (_stream$PassThrough) {
  "use strict";

  _inherits(MediaData, _stream$PassThrough);

  function MediaData(parent) {
    var _this2;

    _classCallCheck(this, MediaData);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MediaData).call(this));
    _this2._parent = parent;
    _this2.destroyed = false;
    return _this2;
  }

  _createClass(MediaData, [{
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;

      this._parent.destroy(err);

      if (err) this.emit('error', err);
      this.emit('close');
    }
  }]);

  return MediaData;
}(stream.PassThrough);

module.exports = Encoder;